import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Form as FinalForm } from 'react-final-form';

import { Button, FieldRadioButton, Form } from '../../../../components';

import css from './EditListingCategoryForm.module.css';

const EditListingCategoryForm = props => {
  return (
    <FinalForm
      {...props}
      render={formRenderProps => {
        const {
          formId,
          className,
          disabled,
          ready,
          handleSubmit,
          intl,
          invalid,
          pristine,
          updated,
          updateInProgress,
          fetchErrors,
          listingFieldsConfig,
          submitButtonText,
          form,
          values,
        } = formRenderProps;

        const classes = classNames(css.root, className);
        const submitReady = (updated && pristine) || ready;
        const submitInProgress = updateInProgress;
        const submitDisabled = invalid || disabled || submitInProgress || !values?.pub_category;
        const { updateListingError, showListingsError } = fetchErrors || {};

        const configsByKey = listingFieldsConfig?.reduce(
          (configs, conf) => ({ ...configs, [conf.key]: conf }),
          {}
        );

        const { enumOptions } = configsByKey?.category || {};

        return (
          <Form onSubmit={handleSubmit} className={classes}>
            {updateListingError ? (
              <p className={css.error}>
                <FormattedMessage id="EditListingCategoryForm.updateFailed" /> //
              </p>
            ) : null}
            {showListingsError ? (
              <p className={css.error}>
                <FormattedMessage id="EditListingCategoryForm.showListingFailed" /> //
              </p>
            ) : null}
            <div className={css.radioGroup}>
              {enumOptions?.map(({ option, label }) => (
                <FieldRadioButton
                  key={formId ? `${formId}.${option}` : option}
                  id={formId ? `${formId}.${option}` : option}
                  name="pub_category"
                  label={intl.formatMessage({ id: label })}
                  value={option}
                  showAsRequired
                  svgClassName={css.radioIcon}
                  className={classNames(css.radioButton, {
                    [css.radioButtonSelected]: values?.pub_category === option,
                  })}
                />
              ))}
            </div>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
              onClick={() => {
                form.change('submitAction', 'saveAndPublish');
              }}
            >
              {submitButtonText}
            </Button>
          </Form>
        );
      }}
    />
  );
};

export default EditListingCategoryForm;
